<soft-filter-value-input [itemConfig]="item()"
                         [operator]="operator()"
                         [value]="draft()"
                         (valueChange)="draft.set($event)"
                         data-testid="date-filter-input" />
